The `Candidate` that this profile relates to.

This contains the candidate's personal details along with all their profiles for the same hirer.
